import { Map } from "immutable";
import { STATE_STATUS, MARKET_DATA_ACTIONS } from "constants";
import { MarketDataRecord } from "records";
const INITIAL_STATE = new Map({
    data: null,
    status: STATE_STATUS.UNFETCHED
});

export default (state = INITIAL_STATE, { type, payload }) => {
    switch(type) {
    case MARKET_DATA_ACTIONS.FETCH_MARKET_DATA:
        return state.set("status", STATE_STATUS.FETCHING);
    case MARKET_DATA_ACTIONS.FETCHED_MARKET_DATA:
        return state
            .set("data", new MarketDataRecord(payload.data))
            .set("status", STATE_STATUS.FETCHED);
    case MARKET_DATA_ACTIONS.FAILED_FETCH_MARKET_DATA:
        return state.set("status", STATE_STATUS.FETCH_FAILED);
    case MARKET_DATA_ACTIONS.CREATE_MARKET_DATA:
        return state.set("status", STATE_STATUS.CREATING);
    case MARKET_DATA_ACTIONS.CREATED_MARKET_DATA:
        return state
            .set("data", new MarketDataRecord(payload.data))
            .set("status", STATE_STATUS.CREATED);
    case MARKET_DATA_ACTIONS.FAILED_CREATE_MARKET_DATA:
        return state.set("status", STATE_STATUS.CREATE_FAILED);
    case MARKET_DATA_ACTIONS.UPDATE_MARKET_DATA:
        return state.set("status", STATE_STATUS.UPDATING);
    case MARKET_DATA_ACTIONS.UPDATED_MARKET_DATA:
        return state
            .set("data", new MarketDataRecord(payload.data))
            .set("status", STATE_STATUS.UPDATED);
    case MARKET_DATA_ACTIONS.FAILED_UPDATE_MARKET_DATA:
        return state.set("status", STATE_STATUS.UPDATE_FAILED);
    default:
        return state;
    }
};